import { render } from "./Threads.vue?vue&type=template&id=34c9e7d7"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"

import "./Threads.vue?vue&type=style&index=0&id=34c9e7d7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__